interface BulkActionsBarProps {
  selectedCount: number;
  onReassign: () => void;
  onHold: () => void;
  onClearSelection: () => void;
}

export const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
  selectedCount,
  onReassign,
  onHold,
  onClearSelection,
}) => {
  return (
    <div className="bulk-actions-bar">
      <div className="bulk-actions-bar__content">
        <div className="bulk-actions-bar__info">
          <span className="bulk-actions-bar__count">{selectedCount}</span>
          <span className="bulk-actions-bar__label">
            ticket{selectedCount !== 1 ? 's' : ''} selected
          </span>
        </div>

        <div className="bulk-actions-bar__actions">
          <button
            className="bulk-actions-bar__btn"
            onClick={onReassign}
            title="Reassign selected tickets"
          >
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
              <circle cx="6" cy="6" r="3" />
              <path d="M1 14c0-2.5 2-4 5-4" />
              <path d="M10 9l3 3-3 3M13 12H8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Reassign
          </button>
          <button
            className="bulk-actions-bar__btn"
            onClick={onHold}
            title="Put selected tickets on hold"
          >
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="3" y="3" width="4" height="10" rx="1" />
              <rect x="9" y="3" width="4" height="10" rx="1" />
            </svg>
            Hold
          </button>
        </div>

        <button
          className="bulk-actions-bar__clear"
          onClick={onClearSelection}
          title="Clear selection"
        >
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M4 4l8 8M12 4l-8 8" strokeLinecap="round" />
          </svg>
          Clear
        </button>
      </div>
    </div>
  );
};
